/**
 * en-GB messages added by Phase 2 task W11 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w11EnGB = {
    // List page
    'prereg.title': 'Pre-registrations',
    'prereg.description': 'Visitors you are expecting. Add them in advance, approve requests and see who has done their pre-arrival steps.',
    'prereg.backToToday': 'Back to Today',
    'prereg.search': 'Search',
    'prereg.allSites': 'All sites',
    'prereg.dates': 'Expected between',
    'prereg.tabs': 'Show pre-registrations by status',
    'prereg.table': 'Pre-registrations',
    'prereg.tab.all': 'All',
    'prereg.tab.expected': 'Expected',
    'prereg.tab.pending_approval': 'Pending approval',
    'prereg.tab.arrived': 'Arrived',
    'prereg.tab.no_show': 'No-show',
    'prereg.tab.cancelled': 'Cancelled',
    'prereg.status.pending_approval': 'Pending approval',
    'prereg.status.expected': 'Expected',
    'prereg.status.arrived': 'Arrived',
    'prereg.status.cancelled': 'Cancelled',
    'prereg.status.no_show': 'No-show',
    'prereg.status.rejected': 'Rejected',
    'prereg.col.visitor': 'Visitor',
    'prereg.col.expected': 'Expected',
    'prereg.col.host': 'Host',
    'prereg.col.status': 'Status',
    'prereg.col.progress': 'Pre-arrival',
    'prereg.col.actions': 'Approval',
    'prereg.decision.approve': 'Approve',
    'prereg.decision.reject': 'Reject',
    'prereg.decision.approveFor': 'Approve {name}',
    'prereg.decision.rejectFor': 'Reject {name}',
    'prereg.decision.rejectTitle': 'Reject {name}',
    'prereg.decision.reason': 'Reason (optional)',
    'prereg.decision.reasonHint': 'The person who asked for this visit is told.',
    'prereg.decision.approved': 'Approved. The visitor has been emailed.',
    'prereg.decision.rejected': 'Rejected.',
    // Progress
    'prereg.progress.label': 'Pre-arrival progress',
    'prereg.progress.opened': 'Opened the page',
    'prereg.progress.confirmed': 'Confirmed the visit',
    'prereg.progress.answers': 'Answered the questions',
    'prereg.progress.notices': 'Accepted the notices',
    'prereg.progress.noticesCount': '{done} of {total}',
    'prereg.progress.photo': 'Added a photo',
    'prereg.progress.car': 'Car registration',
    'prereg.progress.done': 'done',
    'prereg.progress.notYet': 'not yet',
    // Fields shared by the dialog and drawer
    'prereg.field.site': 'Site',
    'prereg.field.group': 'Visitor group',
    'prereg.field.date': 'Date',
    'prereg.field.time': 'Time',
    'prereg.field.lastDay': 'Last day (optional)',
    'prereg.field.lastDayHint': 'For a visit over several days.',
    'prereg.field.until': 'Valid until',
    'prereg.field.hostGroup': 'Host group',
    'prereg.field.host': 'Host',
    'prereg.field.noHost': 'No host',
    'prereg.field.name': 'Name',
    'prereg.field.email': 'Email',
    'prereg.field.phone': 'Phone',
    'prereg.field.company': 'Company',
    'prereg.field.notes': 'Notes',
    // Create dialog
    'prereg.create.open': 'Pre-register',
    'prereg.create.title': 'Pre-register visitors',
    'prereg.create.zone': 'Local time at the site ({zone}).',
    'prereg.create.visitors': 'Visitors',
    'prereg.create.visitorsHint': 'Add up to {max} people for the same visit. Each gets their own email.',
    'prereg.create.visitorN': 'Visitor {n}',
    'prereg.create.addVisitor': 'Add another visitor',
    'prereg.create.removeVisitor': 'Remove visitor {n}',
    'prereg.create.nameRequired': 'Enter a name.',
    'prereg.create.emailInvalid': 'Enter a valid email address.',
    'prereg.create.dateRequired': 'Choose a date.',
    'prereg.create.lastDayBefore': 'The last day cannot be before the first.',
    'prereg.create.sendEmail': 'Send the visitor an email',
    'prereg.create.sendEmailHint': 'Only visitors with an email address are emailed, and only if the group has the email on.',
    'prereg.create.submit': 'Pre-register {count} visitor(s)',
    'prereg.create.done': '{count} visitor(s) pre-registered.',
    'prereg.create.donePending': '{count} visitor(s) pre-registered. {pending} waiting for approval.',
    // Drawer
    'prereg.drawer.title': 'Pre-registration',
    'prereg.drawer.close': 'Close',
    'prereg.drawer.createdBy': 'Added by',
    'prereg.drawer.progress': 'Pre-arrival progress',
    'prereg.drawer.lastActivity': 'Last activity: {when}',
    'prereg.drawer.noActivity': 'The visitor has not done anything yet.',
    'prereg.drawer.email': 'Email',
    'prereg.drawer.resend': 'Send the email again',
    'prereg.drawer.resent': 'The email will be sent again with a fresh link.',
    'prereg.drawer.change': 'Change or cancel',
    'prereg.drawer.edit': 'Edit details',
    'prereg.drawer.saved': 'Saved.',
    'prereg.drawer.resendOnSave': 'Email the visitor the changes',
    'prereg.drawer.resendOnSaveHint': 'A new time is always sent to the visitor.',
    'prereg.drawer.notifyVisitor': 'Tell the visitor it is cancelled',
    'prereg.drawer.cancel': 'Cancel this visit',
    'prereg.drawer.cancelled': 'Cancelled.',
    'prereg.drawer.delete': 'Delete',
    'prereg.drawer.deleted': 'Deleted.',
    'prereg.drawer.noShowAlert': 'This visitor has not arrived',
    'prereg.drawer.newDate': 'New date (optional)',
    'prereg.drawer.newTime': 'New time (optional)',
    'prereg.drawer.runningLate': 'Running late',
    'prereg.drawer.markCancelled': 'Cancelled',
    'prereg.drawer.answered': 'Answer recorded.',
    'prereg.hostAnswer.running_late': 'The host said the visitor is running late.',
    'prereg.hostAnswer.cancelled': 'The host said the visit is cancelled.',
    'prereg.emailStatus.not_sent': 'Not sent',
    'prereg.emailStatus.queued': 'Waiting to be sent',
    'prereg.emailStatus.sent': 'Sent',
    'prereg.emailStatus.failed': 'Failed to send',
    'prereg.emailStatus.off': 'Email is off for this group',
    // Site card: pre-arrival page
    'prereg.site.title': 'Pre-arrival page',
    'prereg.site.description': 'What visitors see on their pre-arrival page before they come to this site.',
    'prereg.site.directions': 'Directions',
    'prereg.site.mapUrl': 'Map link',
    'prereg.site.mapUrlHint': 'A link to the site on a map, starting https://',
    'prereg.site.mapUrlInvalid': 'The link must start with https://',
    'prereg.site.parking': 'Parking',
    'prereg.site.wifiNetwork': 'Wi-Fi network',
    'prereg.site.wifiPassword': 'Wi-Fi password',
    'prereg.site.wifiPasswordHint': 'Shown to visitors with a pre-registration only.',
    'prereg.site.hostContact': 'Contact if they get lost',
    'prereg.site.hostName': 'Contact name',
    'prereg.site.hostPhone': 'Contact phone',
    'prereg.site.hostEmail': 'Contact email',
    'prereg.settings.emailInvalid': 'Enter a valid email address.',
    // Group cards
    'prereg.group.title': 'Pre-registration',
    'prereg.group.description': 'How pre-registration works for this group.',
    'prereg.group.required': 'Only pre-registered people can sign in',
    'prereg.group.requiredHint': 'Kiosks ask for a code or a name from the expected list.',
    'prereg.group.approval': 'Pre-registrations from hosts need approval',
    'prereg.group.approvalHint': 'Requests wait until someone allowed to approve them agrees.',
    'prereg.group.prearrival': 'Pre-arrival page',
    'prereg.group.pa.enabled': 'Send visitors a pre-arrival page',
    'prereg.group.pa.enabledHint': 'A link in the email where they confirm, answer questions and more.',
    'prereg.group.pa.questions': 'Ask the sign-in questions',
    'prereg.group.pa.notices': 'Ask them to accept notices',
    'prereg.group.pa.photo': 'Ask for a photo',
    'prereg.group.pa.car': 'Ask for a car registration',
    'prereg.group.pa.carField': 'Sign-in question for the car registration',
    'prereg.group.pa.carFieldHint': 'The name of the sign-in question for this group (for example Car Reg). A registration given on the pre-arrival page is filled in there on arrival, unless the visitor answered it at the kiosk. Leave empty to turn off.',
    'prereg.group.pa.reschedule': 'Let them change the time',
    'prereg.group.pa.cancel': 'Let them cancel',
    'prereg.group.noShow': 'No-show alert',
    'prereg.group.noShow.after': 'Tell the host after (minutes)',
    'prereg.group.noShow.afterHint': 'Minutes after the expected time. 0 turns the alert off.',
    'prereg.group.noShow.channels': 'Tell the host by',
    'prereg.channel.email': 'Email',
    'prereg.channel.sms': 'Text message',
    'prereg.channel.push': 'App notification',
    'prereg.email.title': 'Expected-visit email',
    'prereg.email.description': 'Sent to a visitor when they are pre-registered. Leave the subject and message empty to use the standard wording.',
    'prereg.email.enabled': 'Send this email',
    'prereg.email.storedAttachment': 'Attached file',
    // Members card
    'prereg.members.lifecycle': 'Keeping the list tidy',
    'prereg.members.archiveAfter': 'Archive members with no visit for (days)',
    'prereg.members.deleteAfter': 'Delete archived members after (days)',
    'prereg.members.zeroOff': '0 turns this off.',
    'prereg.onboarding.title': 'Welcome email',
    'prereg.onboarding.description': 'Sent to new members who have an email address.',
    'prereg.onboarding.enabled': 'Send a welcome email to new members',
    'prereg.onboarding.sendOn': 'Send it',
    'prereg.onboarding.sendOn.created': 'When the member is added',
    'prereg.onboarding.sendOn.start_date': 'At 08:00 on their start date',
    'prereg.onboarding.companion': 'Include a link to set up the Companion app',
    'prereg.onboarding.companionHint': 'Only works when the group has the Companion app turned on.',
};
//# sourceMappingURL=w11.js.map